import { useEffect, useMemo, useState } from "react";
import { Button, Col } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDays,
  faEye,
  faPenToSquare,
  faPlus,
  faSave,
  faTimes,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { APISD } from "../../../../../../config/apisd";

export default function NilaiKhususTab({
  selectedMatpel,
  selectedSemesterId,
  selectedAcademicYearId,
  getToken,
  getUserId,
  getBranchId,
  getSchoolId,
  nameCollator,
  ToastSuccess,
  ToastError,
  setSelectedNilaiKhusus,
}) {
  const [nilaiKhususData, setNilaiKhususData] = useState([]);
  const [selectedKelasId, setSelectedKelasId] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editNilaiKhususId, setEditNilaiKhususId] = useState(null);
  const [typeActivityData, setTypeActivityData] = useState([]);
  const [subActivityData, setSubActivityData] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    ysb_type_activities_id: "",
    ysb_sub_activities_ids: [],
    ysb_kelas_ids: [],
    description: "",
    items: [],
  });

  const [isFetching, setIsFetching] = useState(false);
  const [isFetchingType, setIsFetchingType] = useState(false);
  const [isFetchingSubActivity, setIsFetchingSubActivity] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const safeString = (value) => {
    return value === null || value === undefined ? "" : String(value);
  };

  const cleanStorageValue = (value) => {
    return safeString(value).replace(/[|&;$%@"<>()+,]/g, "");
  };

  const uniqueIds = (values) => {
    const list = Array.isArray(values) ? values : [];

    return [...new Set(list.map((value) => safeString(value)).filter(Boolean))];
  };

  const resolveToken = () => {
    if (typeof getToken === "function") {
      try {
        return getToken() || "";
      } catch (error) {
        return localStorage.getItem("token") || "";
      }
    }

    return localStorage.getItem("token") || "";
  };

  const resolveUserId = () => {
    let userId = "";

    if (typeof getUserId === "function") {
      try {
        userId = getUserId() || "";
      } catch (error) {
        userId = "";
      }
    }

    return cleanStorageValue(
      userId ||
        localStorage.getItem("id_admin") ||
        localStorage.getItem("user_id") ||
        localStorage.getItem("id_user") ||
        localStorage.getItem("userId") ||
        ""
    );
  };

  const resolveBranchId = () => {
    if (typeof getBranchId === "function") {
      try {
        return getBranchId() || localStorage.getItem("ysb_branch_id") || "";
      } catch (error) {
        return localStorage.getItem("ysb_branch_id") || "";
      }
    }

    return localStorage.getItem("ysb_branch_id") || "";
  };

  const resolveSchoolId = () => {
    if (typeof getSchoolId === "function") {
      try {
        return getSchoolId() || localStorage.getItem("ysb_school_id") || "";
      } catch (error) {
        return localStorage.getItem("ysb_school_id") || "";
      }
    }

    return localStorage.getItem("ysb_school_id") || "";
  };

  const showSuccess = (title) => {
    if (ToastSuccess && typeof ToastSuccess.fire === "function") {
      ToastSuccess.fire({
        icon: "success",
        title: title || "Data berhasil disimpan",
      });
      return;
    }

    Swal.fire({
      icon: "success",
      title: title || "Data berhasil disimpan",
      showConfirmButton: false,
      timer: 1600,
    });
  };

  const showError = (title) => {
    if (ToastError && typeof ToastError.fire === "function") {
      ToastError.fire({
        icon: "error",
        title: title || "Terjadi kesalahan",
      });
      return;
    }

    Swal.fire({
      icon: "error",
      title: title || "Terjadi kesalahan",
      confirmButtonText: "Tutup",
    });
  };

  const collator = useMemo(() => {
    return (
      nameCollator ||
      new Intl.Collator("id", {
        sensitivity: "base",
        numeric: true,
      })
    );
  }, [nameCollator]);

  const getArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data)) {
      return responseData.data.data;
    }

    if (Array.isArray(responseData?.data?.rows)) {
      return responseData.data.rows;
    }

    if (Array.isArray(responseData?.data)) {
      return responseData.data;
    }

    if (Array.isArray(responseData?.result?.data)) {
      return responseData.result.data;
    }

    if (Array.isArray(responseData?.result)) {
      return responseData.result;
    }

    if (Array.isArray(responseData)) {
      return responseData;
    }

    return [];
  };

  const kelasList = useMemo(() => {
    const rawKelasList = Array.isArray(selectedMatpel?.kelas_list)
      ? selectedMatpel.kelas_list
      : [];

    const rawAssignments = Array.isArray(selectedMatpel?.assignments)
      ? selectedMatpel.assignments
      : [];

    const kelasMap = new Map();

    [...rawKelasList, ...rawAssignments].forEach((kelas) => {
      const kelasId =
        kelas?.ysb_kelas_id ||
        kelas?.kelas_id ||
        kelas?.id_kelas ||
        kelas?.id ||
        "";

      if (!kelasId) return;

      const previous = kelasMap.get(String(kelasId)) || {};

      kelasMap.set(String(kelasId), {
        ...previous,
        ...kelas,
        ysb_kelas_id: kelasId,
        ysb_grade_level_id:
          kelas?.ysb_grade_level_id ||
          previous?.ysb_grade_level_id ||
          selectedMatpel?.ysb_grade_level_id ||
          "",
        ysb_branch_id:
          kelas?.ysb_branch_id ||
          previous?.ysb_branch_id ||
          selectedMatpel?.ysb_branch_id ||
          "",
        ysb_school_id:
          kelas?.ysb_school_id ||
          previous?.ysb_school_id ||
          selectedMatpel?.ysb_school_id ||
          "",
        ysb_fase_id:
          kelas?.ysb_fase_id ||
          previous?.ysb_fase_id ||
          selectedMatpel?.ysb_fase_id ||
          selectedMatpel?.raw?.ysb_fase_id ||
          "",
        nama_kelas:
          kelas?.nama_kelas ||
          kelas?.name_kelas ||
          kelas?.name_class ||
          kelas?.kelas_name ||
          previous?.nama_kelas ||
          "-",
      });
    });

    return [...kelasMap.values()].sort((a, b) =>
      collator.compare(
        safeString(a?.nama_kelas).trim(),
        safeString(b?.nama_kelas).trim()
      )
    );
  }, [selectedMatpel, collator]);

  const selectedKelasFilter = useMemo(() => {
    return (
      kelasList.find(
        (kelas) =>
          String(kelas?.ysb_kelas_id || "") === String(selectedKelasId || "")
      ) || {}
    );
  }, [kelasList, selectedKelasId]);

  const getSelectedKelas = (kelasId) => {
    return (
      kelasList.find(
        (kelas) =>
          String(kelas?.ysb_kelas_id || "") === String(kelasId || "")
      ) || {}
    );
  };

  const getKelasName = (kelasId) => {
    return getSelectedKelas(kelasId)?.nama_kelas || "-";
  };

  const normalizeTypeActivity = (item) => {
    return {
      id:
        item?.id ||
        item?.ysb_type_activity_id ||
        item?.ysb_type_activities_id ||
        item?.type_activity_id ||
        "",
      ysb_kelas_id: item?.ysb_kelas_id || "",
      ysb_matpel_id: item?.ysb_matpel_id || "",
      ysb_academic_year_id: item?.ysb_academic_year_id || "",
      ysb_semester_id: item?.ysb_semester_id || "",
      input_type: Number(item?.input_type) === 1 ? 1 : 0,
      name_activities:
        item?.name_activities ||
        item?.name_activity ||
        item?.nama_kegiatan ||
        item?.nama_aktivitas ||
        "",
      raw: item,
    };
  };

  const normalizeSubActivity = (item) => {
    return {
      id:
        item?.id ||
        item?.ysb_sub_activity_id ||
        item?.ysb_sub_activities_id ||
        item?.sub_activity_id ||
        "",
      ysb_type_activities_id:
        item?.ysb_type_activities_id ||
        item?.ysb_type_activity_id ||
        item?.type_activity_id ||
        "",
      name_sub_activities:
        item?.name_sub_activities ||
        item?.name_sub_activity ||
        item?.nama_aspek ||
        item?.name_aspek ||
        "",
      raw: item,
    };
  };

  const normalizeNilaiKhusus = (item) => {
    const typeObject =
      item?.type_activity || item?.type_activities || item?.activity_type || {};

    const singleSubObject =
      item?.sub_activity || item?.activity_aspect || item?.sub_activity_detail || {};

    const rawSubObjects = Array.isArray(item?.sub_activities)
      ? item.sub_activities
      : Array.isArray(item?.aspects)
        ? item.aspects
        : [];

    const rawSubIds = Array.isArray(item?.ysb_sub_activities_ids)
      ? item.ysb_sub_activities_ids
      : Array.isArray(item?.sub_activity_ids)
        ? item.sub_activity_ids
        : [];

    const subActivityIds = uniqueIds([
      ...rawSubIds,
      ...rawSubObjects.map(
        (sub) =>
          sub?.id ||
          sub?.ysb_sub_activity_id ||
          sub?.ysb_sub_activities_id ||
          ""
      ),
      item?.ysb_sub_activities_id ||
        item?.ysb_sub_activity_id ||
        singleSubObject?.id ||
        "",
    ]);

    const subActivityNames = [
      ...rawSubObjects.map(
        (sub) =>
          sub?.name_sub_activities ||
          sub?.name_sub_activity ||
          sub?.nama_aspek ||
          sub?.name_aspek ||
          ""
      ),
      item?.name_sub_activities ||
        item?.sub_activity_name ||
        item?.name_sub_activity ||
        singleSubObject?.name_sub_activities ||
        singleSubObject?.name_sub_activity ||
        "",
    ].filter(Boolean);

    // const rawItems = Array.isArray(item?.items)
    //   ? item.items
    //   : Array.isArray(item?.kelas_items)
    //     ? item.kelas_items
    //     : Array.isArray(item?.schedules)
    //       ? item.schedules
    //       : [];

    const rawItems = Array.isArray(item?.items)
      ? item.items
      : Array.isArray(item?.kelas_list)
        ? item.kelas_list
        : Array.isArray(item?.kelas_items)
          ? item.kelas_items
          : Array.isArray(item?.schedules)
            ? item.schedules
            : [];

    // const normalizedItems = rawItems
    //   .map((scheduleItem) => ({
    //     ysb_kelas_id:
    //       scheduleItem?.ysb_kelas_id ||
    //       scheduleItem?.kelas_id ||
    //       scheduleItem?.id_kelas ||
    //       scheduleItem?.kelas?.id ||
    //       "",
    //     date_exam:
    //       scheduleItem?.date_exam ||
    //       scheduleItem?.date ||
    //       scheduleItem?.tanggal ||
    //       "",
    //     kelas_name:
    //       scheduleItem?.nama_kelas ||
    //       scheduleItem?.kelas_name ||
    //       scheduleItem?.kelas?.nama_kelas ||
    //       scheduleItem?.kelas?.name_kelas ||
    //       "",
    //   }))
    //   .filter((scheduleItem) => scheduleItem.ysb_kelas_id);
    const normalizedItems = rawItems
      .map((scheduleItem) => ({
        ysb_kelas_id:
          scheduleItem?.ysb_kelas_id ||
          scheduleItem?.kelas_id ||
          scheduleItem?.id_kelas ||
          scheduleItem?.kelas?.id ||
          "",

        date_exam:
          scheduleItem?.date_exam ||
          scheduleItem?.date ||
          scheduleItem?.tanggal ||
          "",

        kelas_name:
          scheduleItem?.nama_kelas ||
          scheduleItem?.name_kelas ||
          scheduleItem?.kelas_name ||
          scheduleItem?.kelas?.nama_kelas ||
          scheduleItem?.kelas?.name_kelas ||
          "",
      }))
      .filter((scheduleItem) => scheduleItem.ysb_kelas_id);

    if (normalizedItems.length === 0 && item?.ysb_kelas_id) {
      normalizedItems.push({
        ysb_kelas_id: item.ysb_kelas_id,
        date_exam:
          item?.date_exam || item?.date || item?.tanggal || "",
        kelas_name:
          item?.nama_kelas || item?.kelas_name || item?.kelas?.nama_kelas || "",
      });
    }

    const explicitKelasIds = Array.isArray(item?.ysb_kelas_ids)
      ? item.ysb_kelas_ids
      : [];

    const kelasIds = uniqueIds([
      ...explicitKelasIds,
      ...normalizedItems.map((scheduleItem) => scheduleItem.ysb_kelas_id),
      item?.ysb_kelas_id || "",
    ]);

    const kelasObject = item?.kelas || item?.class || {};
    const creatorObject =
      item?.creator ||
      item?.create_user ||
      item?.user_create ||
      item?.created_by_user ||
      {};

    const totalDinilai =
      item?.total_dinilai ??
      item?.total_assessed ??
      item?.sudah_dinilai ??
      item?.assessed_count ??
      item?.count_assessed ??
      null;

    const totalSiswa =
      item?.total_siswa ??
      item?.total_students ??
      item?.jumlah_siswa ??
      item?.student_count ??
      item?.count_students ??
      null;

    return {
      id:
        item?.id ||
        item?.ysb_exam_kokurikuler_id ||
        item?.exam_kokurikuler_id ||
        "",
      ysb_fase_id: item?.ysb_fase_id || "",
      ysb_academic_year_id: item?.ysb_academic_year_id || "",
      ysb_semester_id: item?.ysb_semester_id || "",
      ysb_branch_id: item?.ysb_branch_id || "",
      ysb_school_id: item?.ysb_school_id || "",
      ysb_grade_level_id: item?.ysb_grade_level_id || "",
      ysb_kelas_id: item?.ysb_kelas_id || kelasIds[0] || "",
      ysb_kelas_ids: kelasIds,
      ysb_matpel_id: item?.ysb_matpel_id || "",
      ysb_type_activities_id:
        item?.ysb_type_activities_id ||
        item?.ysb_type_activity_id ||
        typeObject?.id ||
        "",
      ysb_sub_activities_id: subActivityIds[0] || "",
      ysb_sub_activities_ids: subActivityIds,
      title: item?.title || item?.name || item?.judul || "",
      description:
        item?.description || item?.keterangan || item?.information || "",
      date:
        item?.date ||
        item?.date_exam ||
        item?.tanggal ||
        normalizedItems?.[0]?.date_exam ||
        "",
      type_activity_name:
        item?.name_activities ||
        item?.type_activity_name ||
        item?.name_type_activity ||
        typeObject?.name_activities ||
        typeObject?.name_activity ||
        "",
      sub_activity_name: [...new Set(subActivityNames)].join(", "),
      sub_activity_names: [...new Set(subActivityNames)],
      kelas_name:
        item?.nama_kelas ||
        item?.name_kelas ||
        item?.kelas_name ||
        kelasObject?.nama_kelas ||
        kelasObject?.name_kelas ||
        normalizedItems?.[0]?.kelas_name ||
        "",
      creator_name:
        item?.create_by_data ||
        item?.created_by_name ||
        item?.user_name ||
        item?.name_user ||
        creatorObject?.name ||
        creatorObject?.nama_lengkap ||
        item?.create_by ||
        "-",
      create_by: item?.create_by || "",
      update_by: item?.update_by || "",
      created_at: item?.created_at || "",
      updated_at: item?.updated_at || "",
      total_dinilai: totalDinilai,
      total_siswa: totalSiswa,
      items: normalizedItems,
      raw: item,
    };
  };

  const formatDate = (value, withTime = false) => {
    if (!value) return "-";

    const raw = safeString(value);
    const date = new Date(raw);

    if (Number.isNaN(date.getTime())) {
      return raw;
    }

    return date.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      ...(withTime
        ? {
            hour: "2-digit",
            minute: "2-digit",
          }
        : {}),
    });
  };

  const getAssessedText = (item) => {
    const totalDinilaiNumber = Number(item?.total_dinilai);
    const totalSiswaNumber = Number(item?.total_siswa);

    const totalDinilai = Number.isFinite(totalDinilaiNumber)
      ? totalDinilaiNumber
      : 0;

    const totalSiswa = Number.isFinite(totalSiswaNumber)
      ? totalSiswaNumber
      : 0;

    return `${totalDinilai}/${totalSiswa}`;
  };

  const getNestedValue = (source, paths) => {
    for (const path of paths) {
      const value = path
        .split(".")
        .reduce((current, key) => current?.[key], source);

      if (value !== undefined && value !== null) {
        return value;
      }
    }

    return undefined;
  };

  const toOptionalNumber = (value) => {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : null;
  };

  const getScoreStudents = (source) => {
    const candidates = [
      source?.data?.data?.data_murid,
      source?.data?.data?.students,
      source?.data?.data_murid,
      source?.data?.students,
      source?.result?.data?.data_murid,
      source?.result?.data?.students,
      source?.data_murid,
      source?.students,
      source?.murid,
      source?.data_students,
      source?.student_list,
      source?.list_students,
      source?.score_data?.data_murid,
      source?.score_data?.students,
      source?.nilai?.data_murid,
      source?.nilai?.students,
      source?.data_nilai?.data_murid,
      source?.result?.data_murid,
      source?.result?.students,
    ];

    return candidates.find((item) => Array.isArray(item)) || [];
  };

  const getFlatScores = (source) => {
    const candidates = [
      source?.data?.data?.scores,
      source?.data?.data?.score_list,
      source?.data?.scores,
      source?.data?.score_list,
      source?.result?.data?.scores,
      source?.result?.data?.score_list,
      source?.scores,
      source?.score_list,
      source?.exam_scores,
      source?.nilai_siswa,
      source?.score_data?.scores,
      source?.result?.scores,
    ];

    return candidates.find((item) => Array.isArray(item)) || [];
  };

  const getScoreAspects = (source) => {
    const candidates = [
      source?.data?.data?.header,
      source?.data?.data?.headers,
      source?.data?.data?.aspects,
      source?.data?.data?.sub_activities,
      source?.data?.header,
      source?.data?.headers,
      source?.data?.aspects,
      source?.data?.sub_activities,
      source?.result?.data?.header,
      source?.result?.data?.headers,
      source?.result?.data?.aspects,
      source?.result?.data?.sub_activities,
      source?.header,
      source?.headers,
      source?.aspects,
      source?.sub_activities,
    ];

    return candidates.find((item) => Array.isArray(item)) || [];
  };

  const getAspectId = (item) => {
    return safeString(
      item?.id ||
        item?.ysb_sub_activities_id ||
        item?.ysb_sub_activity_id ||
        item?.sub_activity_id ||
        item?.aspect_id ||
        item?.ysb_aspect_id ||
        ""
    );
  };

  const getStudentIdFromScore = (item, index = 0) => {
    return safeString(
      item?.ysb_student_id ||
        item?.student_id ||
        item?.id_student ||
        item?.ysb_murid_id ||
        item?.student?.id ||
        item?.murid?.id ||
        item?.siswa?.id ||
        item?.id ||
        `student-${index}`
    );
  };

  const getStudentScores = (student) => {
    const candidates = [
      student?.data_nilai,
      student?.scores,
      student?.nilai_aspek,
      student?.score_list,
      student?.exam_scores,
      student?.exam_kokurikuler_scores,
      student?.kokurikuler_scores,
      student?.score_details,
      student?.aspects,
    ];

    return candidates.find((item) => Array.isArray(item)) || [];
  };

  const getScoreAspectId = (score) => {
    return safeString(
      score?.ysb_sub_activities_id ||
        score?.ysb_sub_activity_id ||
        score?.sub_activity_id ||
        score?.aspect_id ||
        score?.ysb_aspect_id ||
        score?.sub_activity?.id ||
        ""
    );
  };

  const hasFilledScore = (score) => {
    const value =
      score?.score_value ??
      score?.score_text ??
      score?.score ??
      score?.value ??
      score?.nilai ??
      score?.ysb_value ??
      score?.result ??
      score?.text ??
      "";

    return value !== null && value !== undefined && safeString(value).trim() !== "";
  };

  const normalizeScoreStudents = (source) => {
    const studentMap = new Map();

    getScoreStudents(source).forEach((student, index) => {
      const studentId = getStudentIdFromScore(student, index);

      studentMap.set(studentId, {
        id: studentId,
        scores: getStudentScores(student),
        raw: student,
      });
    });

    getFlatScores(source).forEach((score, index) => {
      const studentId = getStudentIdFromScore(score, index);
      const previous = studentMap.get(studentId) || {
        id: studentId,
        scores: [],
        raw: score?.student || score?.murid || score?.siswa || {},
      };

      studentMap.set(studentId, {
        ...previous,
        scores: [...previous.scores, score],
      });
    });

    return [...studentMap.values()];
  };

  const getAssessmentSummaryFromResponse = (source, row) => {
    const explicitTotalSiswa = toOptionalNumber(
      getNestedValue(source, [
        "data.data.total_siswa",
        "data.total_siswa",
        "result.data.total_siswa",
        "result.total_siswa",
        "total_siswa",
        "data.data.total_students",
        "data.total_students",
        "result.data.total_students",
        "result.total_students",
        "total_students",
      ])
    );

    const explicitTotalDinilai = toOptionalNumber(
      getNestedValue(source, [
        "data.data.total_dinilai",
        "data.total_dinilai",
        "result.data.total_dinilai",
        "result.total_dinilai",
        "total_dinilai",
        "data.data.total_assessed",
        "data.total_assessed",
        "result.data.total_assessed",
        "result.total_assessed",
        "total_assessed",
      ])
    );

    const students = normalizeScoreStudents(source);

    const rowAspectIds = uniqueIds([
      ...(Array.isArray(row?.ysb_sub_activities_ids)
        ? row.ysb_sub_activities_ids
        : []),
      row?.ysb_sub_activities_id || "",
    ]);

    const responseAspectIds = uniqueIds(
      getScoreAspects(source).map((aspect) => getAspectId(aspect))
    );

    const aspectIds = uniqueIds([
      ...rowAspectIds,
      ...responseAspectIds,
    ]);

    const totalDinilaiFromStudents = students.filter((student) => {
      const scores = Array.isArray(student?.scores) ? student.scores : [];

      if (aspectIds.length > 0) {
        return aspectIds.every((aspectId) => {
          const matchedScore = scores.find(
            (score) => getScoreAspectId(score) === String(aspectId)
          );

          return matchedScore ? hasFilledScore(matchedScore) : false;
        });
      }

      if (scores.length > 0) {
        return scores.some((score) => hasFilledScore(score));
      }

      return hasFilledScore(student?.raw || {});
    }).length;

    return {
      total_siswa:
        explicitTotalSiswa !== null ? explicitTotalSiswa : students.length,
      total_dinilai:
        students.length > 0
          ? totalDinilaiFromStudents
          : explicitTotalDinilai !== null
            ? explicitTotalDinilai
            : 0,
    };
  };

  const getNilaiKhususAssessmentSummary = async (row, kelasId) => {
    const targetKelasId = kelasId || row?.ysb_kelas_id || "";
    const selectedKelas = getSelectedKelas(targetKelasId);

    if (!row?.id || !targetKelasId) {
      return {
        total_dinilai: toOptionalNumber(row?.total_dinilai) ?? 0,
        total_siswa: toOptionalNumber(row?.total_siswa) ?? 0,
      };
    }

    try {
      const response = await APISD.post(
        "/api/exam-kokurikuler-score",
        {
          ysb_branch_id:
            selectedKelas?.ysb_branch_id ||
            row?.ysb_branch_id ||
            resolveBranchId() ||
            "",
          ysb_school_id:
            selectedKelas?.ysb_school_id ||
            row?.ysb_school_id ||
            resolveSchoolId() ||
            "",
          ysb_kelas_id: targetKelasId,
          ysb_exam_kokurikuler_id: row.id,
        },
        {
          headers: {
            Authorization: resolveToken(),
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      return getAssessmentSummaryFromResponse(response?.data || {}, row);
    } catch (error) {
      console.log(
        `Gagal mengambil jumlah siswa yang sudah dinilai untuk ${row?.title || row?.id}:`,
        error
      );

      return {
        total_dinilai: toOptionalNumber(row?.total_dinilai) ?? 0,
        total_siswa: toOptionalNumber(row?.total_siswa) ?? 0,
      };
    }
  };

  const createEmptyForm = (defaultKelasId = "") => {
    const kelasId = safeString(defaultKelasId);

    return {
      title: "",
      ysb_type_activities_id: "",
      ysb_sub_activities_ids: [],
      ysb_kelas_ids: kelasId ? [kelasId] : [],
      description: "",
      items: kelasId
        ? [
            {
              ysb_kelas_id: kelasId,
              date_exam: "",
            },
          ]
        : [],
    };
  };

  const resetForm = () => {
    setEditNilaiKhususId(null);
    setFormData(createEmptyForm(selectedKelasId || kelasList?.[0]?.ysb_kelas_id));
    setTypeActivityData([]);
    setSubActivityData([]);
  };

  const getNilaiKhususData = async (kelasIdParam = selectedKelasId) => {
    const kelasId = kelasIdParam || selectedKelasId;

    if (!kelasId) {
      setNilaiKhususData([]);
      setIsFetching(false);
      return;
    }

    setIsFetching(true);

    try {
      const selectedKelas = getSelectedKelas(kelasId);
      const selectedMatpelId =
        selectedMatpel?.ysb_matpel_id || selectedMatpel?.id || "";

      const requestPayload = {
        page: 1,
        limit: 1000,
        ascending: 1,
        search: "",
        branch: selectedKelas?.ysb_branch_id || resolveBranchId() || "",
        level: localStorage.getItem("level") || "developer",
        ysb_academic_year_id: selectedAcademicYearId || "",
        ysb_semester_id: selectedSemesterId || "",
        ysb_branch_id: selectedKelas?.ysb_branch_id || resolveBranchId() || "",
        ysb_school_id: selectedKelas?.ysb_school_id || resolveSchoolId() || "",
        ysb_grade_level_id:
          selectedKelas?.ysb_grade_level_id ||
          selectedMatpel?.ysb_grade_level_id ||
          "",
        ysb_matpel_id: selectedMatpelId,
        ysb_kelas_id: kelasId,
      };

      const response = await APISD.request({
        method: "GET",
        url: "/api/exam-kokurikuler",
        headers: {
          Authorization: resolveToken(),
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        params: requestPayload,
      });

      const rows = getArrayFromResponse(response?.data)
        .map(normalizeNilaiKhusus)
        .filter((item) => {
          const itemKelasIds = uniqueIds([
            ...(item?.ysb_kelas_ids || []),
            item?.ysb_kelas_id || "",
          ]);

          // const sameKelas =
          //   itemKelasIds.length === 0 || itemKelasIds.includes(String(kelasId));

          const sameKelas =
            itemKelasIds.length > 0 &&
            itemKelasIds.includes(String(kelasId));

          const sameAcademicYear =
            !item?.ysb_academic_year_id ||
            !selectedAcademicYearId ||
            String(item?.ysb_academic_year_id) ===
              String(selectedAcademicYearId);

          const sameSemester =
            !item?.ysb_semester_id ||
            !selectedSemesterId ||
            String(item?.ysb_semester_id) === String(selectedSemesterId);

          const sameMatpel =
            !item?.ysb_matpel_id ||
            !selectedMatpelId ||
            String(item?.ysb_matpel_id) === String(selectedMatpelId);

          const sameGradeLevel =
            !item?.ysb_grade_level_id ||
            !selectedMatpel?.ysb_grade_level_id ||
            String(item?.ysb_grade_level_id) ===
              String(selectedMatpel?.ysb_grade_level_id);

          return (
            sameKelas &&
            sameAcademicYear &&
            sameSemester &&
            sameMatpel &&
            sameGradeLevel
          );
        });

      // const rowsWithAssessmentSummary = await Promise.all(
      //   rows.map(async (row) => {
      //     const summary = await getNilaiKhususAssessmentSummary(row, kelasId);

      //     return {
      //       ...row,
      //       ...summary,
      //     };
      //   })
      // );

      // setNilaiKhususData(rowsWithAssessmentSummary);
      const normalizedRows = rows.map((row) => ({
  ...row,

  total_dinilai:
    toOptionalNumber(row?.total_dinilai) ??
    toOptionalNumber(row?.raw?.total_dinilai) ??
    toOptionalNumber(row?.raw?.total_assessed) ??
    toOptionalNumber(row?.raw?.sudah_dinilai) ??
    0,

  total_siswa:
    toOptionalNumber(row?.total_siswa) ??
    toOptionalNumber(row?.raw?.total_siswa) ??
    toOptionalNumber(row?.raw?.total_students) ??
    toOptionalNumber(row?.raw?.jumlah_siswa) ??
    0,
}));

setNilaiKhususData(normalizedRows);
        } catch (error) {
          console.log("Gagal mengambil data nilai khusus:", error);
          setNilaiKhususData([]);
          showError(
            error?.response?.data?.message || "Gagal mengambil data nilai khusus"
          );
        } finally {
          setIsFetching(false);
        }
      };

  const getTypeActivityData = async (kelasId) => {
    if (!kelasId) {
      setTypeActivityData([]);
      return;
    }

    setIsFetchingType(true);
    setTypeActivityData([]);

    try {
      const selectedKelas = getSelectedKelas(kelasId);

      const requestPayload = {
        page: 1,
        limit: 1000,
        ascending: true,
        search: "",
        branch: selectedKelas?.ysb_branch_id || resolveBranchId() || "",
        ysb_kelas_id: kelasId,
        level: localStorage.getItem("level") || "user",
      };

      const response = await APISD.request({
        method: "GET",
        url: "/api/type-activities",
        headers: {
          Authorization: resolveToken(),
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: requestPayload,
      });

      const matpelId = selectedMatpel?.ysb_matpel_id || selectedMatpel?.id || "";

      const rows = getArrayFromResponse(response?.data)
        .map(normalizeTypeActivity)
        .filter((item) => {
          const sameKelas =
            !item?.ysb_kelas_id ||
            String(item?.ysb_kelas_id || "") === String(kelasId);

          const sameMatpel =
            !item?.ysb_matpel_id ||
            !matpelId ||
            String(item?.ysb_matpel_id) === String(matpelId);

          const sameAcademicYear =
            !item?.ysb_academic_year_id ||
            !selectedAcademicYearId ||
            String(item?.ysb_academic_year_id) ===
              String(selectedAcademicYearId);

          const sameSemester =
            !item?.ysb_semester_id ||
            !selectedSemesterId ||
            String(item?.ysb_semester_id) === String(selectedSemesterId);

          return sameKelas && sameMatpel && sameAcademicYear && sameSemester;
        })
        .sort((a, b) =>
          collator.compare(
            safeString(a?.name_activities).trim(),
            safeString(b?.name_activities).trim()
          )
        );

      setTypeActivityData(rows);
    } catch (error) {
      console.log("Gagal mengambil kegiatan:", error);
      setTypeActivityData([]);
      showError(error?.response?.data?.message || "Gagal mengambil kegiatan");
    } finally {
      setIsFetchingType(false);
    }
  };

  const getSubActivityData = async (typeActivityId) => {
    if (!typeActivityId) {
      setSubActivityData([]);
      return;
    }

    setIsFetchingSubActivity(true);
    setSubActivityData([]);

    try {
      const requestPayload = {
        page: 1,
        limit: 1000,
        ascending: true,
        search: "",
        branch: "",
        level: localStorage.getItem("level") || "developer",
        ysb_type_activities_id: typeActivityId,
      };

      const response = await APISD.request({
        method: "GET",
        url: "/api/sub-activities",
        headers: {
          Authorization: resolveToken(),
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: requestPayload,
      });

      const rows = getArrayFromResponse(response?.data)
        .map(normalizeSubActivity)
        .filter((item) => {
          return (
            !item?.ysb_type_activities_id ||
            String(item?.ysb_type_activities_id) === String(typeActivityId)
          );
        })
        .sort((a, b) =>
          collator.compare(
            safeString(a?.name_sub_activities).trim(),
            safeString(b?.name_sub_activities).trim()
          )
        );

      setSubActivityData(rows);
    } catch (error) {
      console.log("Gagal mengambil aspek kegiatan:", error);
      setSubActivityData([]);
      showError(
        error?.response?.data?.message || "Gagal mengambil aspek kegiatan"
      );
    } finally {
      setIsFetchingSubActivity(false);
    }
  };

  useEffect(() => {
    const availableKelasIds = kelasList
      .map((kelas) => String(kelas?.ysb_kelas_id || ""))
      .filter(Boolean);

    setSelectedKelasId((currentId) => {
      if (currentId && availableKelasIds.includes(String(currentId))) {
        return currentId;
      }

      return availableKelasIds[0] || "";
    });
  }, [
    kelasList,
    selectedMatpel?.row_key,
    selectedMatpel?.id,
    selectedMatpel?.ysb_matpel_id,
  ]);

  useEffect(() => {
    setSearchKeyword("");
    setShowModal(false);
    setNilaiKhususData([]);
    setTypeActivityData([]);
    setSubActivityData([]);
    setEditNilaiKhususId(null);
    setFormData(createEmptyForm());
  }, [
    selectedMatpel?.row_key,
    selectedMatpel?.id,
    selectedMatpel?.ysb_matpel_id,
    selectedMatpel?.ysb_grade_level_id,
    selectedAcademicYearId,
    selectedSemesterId,
  ]);

  useEffect(() => {
    if (!selectedKelasId) {
      setNilaiKhususData([]);
      return;
    }

    getNilaiKhususData(selectedKelasId);
  }, [
    selectedKelasId,
    selectedMatpel?.row_key,
    selectedMatpel?.id,
    selectedMatpel?.ysb_matpel_id,
    selectedMatpel?.ysb_grade_level_id,
    selectedAcademicYearId,
    selectedSemesterId,
  ]);

  const activityReferenceKelasId = useMemo(() => {
    const firstSelectedKelasId = Array.isArray(formData?.ysb_kelas_ids)
      ? formData.ysb_kelas_ids[0]
      : "";

    return (
      firstSelectedKelasId || selectedKelasId || kelasList?.[0]?.ysb_kelas_id || ""
    );
  }, [formData?.ysb_kelas_ids, selectedKelasId, kelasList]);

  useEffect(() => {
    if (!showModal || !activityReferenceKelasId) {
      return;
    }

    getTypeActivityData(activityReferenceKelasId);
  }, [showModal, activityReferenceKelasId]);

  useEffect(() => {
    if (!showModal || !formData.ysb_type_activities_id) {
      setSubActivityData([]);
      return;
    }

    getSubActivityData(formData.ysb_type_activities_id);
  }, [showModal, formData.ysb_type_activities_id]);

  const filteredData = useMemo(() => {
    const keyword = safeString(searchKeyword).trim().toLowerCase();

    const rows = !keyword
      ? nilaiKhususData
      : nilaiKhususData.filter((item) => {
          const text = [
            item?.title,
            item?.type_activity_name,
            item?.sub_activity_name,
            item?.kelas_name,
            item?.creator_name,
            item?.description,
          ]
            .map((value) => safeString(value).toLowerCase())
            .join(" ");

          return text.includes(keyword);
        });

    return [...rows].sort((a, b) => {
      const dateA = new Date(a?.created_at || 0).getTime();
      const dateB = new Date(b?.created_at || 0).getTime();

      if (dateA !== dateB) {
        return dateB - dateA;
      }

      return collator.compare(
        safeString(a?.title).trim(),
        safeString(b?.title).trim()
      );
    });
  }, [nilaiKhususData, searchKeyword, collator]);

  const selectedKelasIds = Array.isArray(formData?.ysb_kelas_ids)
    ? formData.ysb_kelas_ids
    : [];

  const selectedSubActivityIds = Array.isArray(
    formData?.ysb_sub_activities_ids
  )
    ? formData.ysb_sub_activities_ids
    : [];

  const isAllKelasSelected =
    kelasList.length > 0 &&
    kelasList
      .map((kelas) => safeString(kelas?.ysb_kelas_id))
      .filter(Boolean)
      .every((kelasId) => selectedKelasIds.includes(kelasId));

  const getJadwalKelas = (kelasId) => {
    const items = Array.isArray(formData?.items) ? formData.items : [];

    return (
      items.find(
        (item) => String(item?.ysb_kelas_id || "") === String(kelasId || "")
      ) || {
        ysb_kelas_id: kelasId,
        date_exam: "",
      }
    );
  };

  const handleOpenAdd = () => {
    if (!selectedKelasId && kelasList.length === 0) {
      showError("Kelas belum tersedia");
      return;
    }

    const defaultKelasId = selectedKelasId || kelasList?.[0]?.ysb_kelas_id || "";

    setEditNilaiKhususId(null);
    setFormData(createEmptyForm(defaultKelasId));
    setTypeActivityData([]);
    setSubActivityData([]);
    setShowModal(true);
  };

  const handleOpenEdit = (item) => {
    if (!item?.id) {
      showError("ID nilai khusus tidak ditemukan");
      return;
    }

    const normalizedItem = item?.raw ? item : normalizeNilaiKhusus(item);

    const editItems = Array.isArray(normalizedItem?.items)
      ? normalizedItem.items
          .map((scheduleItem) => ({
            ysb_kelas_id: safeString(scheduleItem?.ysb_kelas_id),
            date_exam: scheduleItem?.date_exam
              ? safeString(scheduleItem.date_exam).slice(0, 10)
              : "",
          }))
          .filter((scheduleItem) => scheduleItem.ysb_kelas_id)
      : [];

    if (editItems.length === 0) {
      const fallbackKelasId =
        normalizedItem?.ysb_kelas_id ||
        selectedKelasId ||
        kelasList?.[0]?.ysb_kelas_id ||
        "";

      if (fallbackKelasId) {
        editItems.push({
          ysb_kelas_id: safeString(fallbackKelasId),
          date_exam: normalizedItem?.date
            ? safeString(normalizedItem.date).slice(0, 10)
            : "",
        });
      }
    }

    const editKelasIds = uniqueIds(
      editItems.map((scheduleItem) => scheduleItem.ysb_kelas_id)
    );

    const editSubActivityIds = uniqueIds([
      ...(normalizedItem?.ysb_sub_activities_ids || []),
      normalizedItem?.ysb_sub_activities_id || "",
    ]);

    setEditNilaiKhususId(normalizedItem.id);
    setFormData({
      title: normalizedItem?.title || "",
      ysb_type_activities_id:
        normalizedItem?.ysb_type_activities_id || "",
      ysb_sub_activities_ids: editSubActivityIds,
      ysb_kelas_ids: editKelasIds,
      description: normalizedItem?.description || "",
      items: editItems,
    });
    setTypeActivityData([]);
    setSubActivityData([]);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    if (isSubmitting) return;

    setShowModal(false);
    resetForm();
  };

  const handleChangeForm = (event) => {
    const { name, value } = event.target;

    setFormData((previous) => {
      if (name === "ysb_type_activities_id") {
        return {
          ...previous,
          ysb_type_activities_id: value,
          ysb_sub_activities_ids: [],
        };
      }

      return {
        ...previous,
        [name]: value,
      };
    });
  };

  const handleChangeSubActivity = (subActivityId) => {
    const targetId = safeString(subActivityId);
    if (!targetId || isSubmitting) return;

    setFormData((previous) => {
      const currentIds = Array.isArray(previous?.ysb_sub_activities_ids)
        ? previous.ysb_sub_activities_ids
        : [];

      const alreadySelected = currentIds.includes(targetId);

      return {
        ...previous,
        ysb_sub_activities_ids: alreadySelected
          ? currentIds.filter((id) => id !== targetId)
          : [...currentIds, targetId],
      };
    });
  };

  const handleChangeKelas = (kelasId) => {
    const targetId = safeString(kelasId);
    if (!targetId || isSubmitting) return;

    setFormData((previous) => {
      const currentKelasIds = Array.isArray(previous?.ysb_kelas_ids)
        ? previous.ysb_kelas_ids
        : [];
      const currentItems = Array.isArray(previous?.items) ? previous.items : [];
      const alreadySelected = currentKelasIds.includes(targetId);

      if (alreadySelected) {
        return {
          ...previous,
          ysb_kelas_ids: currentKelasIds.filter((id) => id !== targetId),
          items: currentItems.filter(
            (item) => String(item?.ysb_kelas_id || "") !== targetId
          ),
        };
      }

      return {
        ...previous,
        ysb_kelas_ids: [...currentKelasIds, targetId],
        items: [
          ...currentItems,
          {
            ysb_kelas_id: targetId,
            date_exam: "",
          },
        ],
      };
    });
  };

  const handleSelectAllKelas = () => {
    if (isSubmitting) return;

    setFormData((previous) => {
      const allKelasIds = kelasList
        .map((kelas) => safeString(kelas?.ysb_kelas_id))
        .filter(Boolean);

      if (isAllKelasSelected) {
        return {
          ...previous,
          ysb_kelas_ids: [],
          items: [],
        };
      }

      const currentItems = Array.isArray(previous?.items) ? previous.items : [];

      const nextItems = allKelasIds.map((kelasId) => {
        const existingItem = currentItems.find(
          (item) => String(item?.ysb_kelas_id || "") === String(kelasId)
        );

        return (
          existingItem || {
            ysb_kelas_id: kelasId,
            date_exam: "",
          }
        );
      });

      return {
        ...previous,
        ysb_kelas_ids: allKelasIds,
        items: nextItems,
      };
    });
  };

  const handleChangeTanggalKelas = (kelasId, value) => {
    const targetId = safeString(kelasId);

    setFormData((previous) => {
      const currentItems = Array.isArray(previous?.items) ? previous.items : [];
      const hasItem = currentItems.some(
        (item) => String(item?.ysb_kelas_id || "") === targetId
      );

      const nextItems = hasItem
        ? currentItems.map((item) =>
            String(item?.ysb_kelas_id || "") === targetId
              ? {
                  ...item,
                  date_exam: value,
                }
              : item
          )
        : [
            ...currentItems,
            {
              ysb_kelas_id: targetId,
              date_exam: value,
            },
          ];

      return {
        ...previous,
        items: nextItems,
      };
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) return;

    const kelasIds = uniqueIds(formData?.ysb_kelas_ids);
    const subActivityIds = uniqueIds(formData?.ysb_sub_activities_ids);
    const firstKelasId = kelasIds[0] || selectedKelasId || "";
    const firstSelectedKelas = getSelectedKelas(firstKelasId);
    const matpelId = selectedMatpel?.ysb_matpel_id || selectedMatpel?.id || "";

    const items = kelasIds.map((kelasId) => {
      const scheduleItem = getJadwalKelas(kelasId);

      return {
        ysb_kelas_id: kelasId,
        date_exam: scheduleItem?.date_exam || "",
      };
    });

    const payload = {
      ysb_fase_id:
        firstSelectedKelas?.ysb_fase_id ||
        selectedMatpel?.ysb_fase_id ||
        selectedMatpel?.raw?.ysb_fase_id ||
        "",
      ysb_academic_year_id: selectedAcademicYearId || "",
      ysb_semester_id: selectedSemesterId || "",
      ysb_branch_id:
        firstSelectedKelas?.ysb_branch_id ||
        selectedMatpel?.ysb_branch_id ||
        resolveBranchId(),
      ysb_school_id:
        firstSelectedKelas?.ysb_school_id ||
        selectedMatpel?.ysb_school_id ||
        resolveSchoolId(),
      ysb_grade_level_id:
        firstSelectedKelas?.ysb_grade_level_id ||
        selectedMatpel?.ysb_grade_level_id ||
        "",
      ysb_matpel_id: matpelId,
      ysb_type_activities_id: formData.ysb_type_activities_id || "",
      ysb_input_type_id: 2,
      ysb_sub_activities_ids: subActivityIds,
      title: safeString(formData.title).trim(),
      description: safeString(formData.description).trim(),
      items,
      user_id: resolveUserId(),
    };

    if (!payload.title) {
      showError("Judul wajib diisi");
      return;
    }

    if (!payload.ysb_type_activities_id) {
      showError("Kegiatan wajib dipilih");
      return;
    }

    if (payload.ysb_sub_activities_ids.length === 0) {
      showError("Pilih minimal satu aspek kegiatan");
      return;
    }

    if (payload.items.length === 0) {
      showError("Pilih minimal satu kelas");
      return;
    }

    const incompleteSchedule = payload.items.find((item) => !item.date_exam);

    if (incompleteSchedule) {
      showError(
        `Tanggal penilaian kelas ${getKelasName(
          incompleteSchedule.ysb_kelas_id
        )} wajib diisi`
      );
      return;
    }

    if (!payload.ysb_academic_year_id) {
      showError("Tahun ajaran tidak ditemukan");
      return;
    }

    if (!payload.ysb_semester_id) {
      showError("Semester tidak ditemukan");
      return;
    }

    if (!payload.ysb_branch_id) {
      showError("ID cabang tidak ditemukan");
      return;
    }

    if (!payload.ysb_school_id) {
      showError("ID sekolah tidak ditemukan");
      return;
    }

    if (!payload.ysb_grade_level_id) {
      showError("ID tingkatan tidak ditemukan");
      return;
    }

    if (!payload.ysb_matpel_id) {
      showError("ID mata pelajaran tidak ditemukan");
      return;
    }

    if (!payload.user_id) {
      showError("ID user tidak ditemukan. Silakan login ulang.");
      return;
    }

    setIsSubmitting(true);

    try {
      let response;

      if (editNilaiKhususId) {
        response = await APISD.put(
          `/api/exam-kokurikuler/${editNilaiKhususId}`,
          payload,
          {
            headers: {
              Authorization: resolveToken(),
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
      } else {
        response = await APISD.post("/api/exam-kokurikuler/store", payload, {
          headers: {
            Authorization: resolveToken(),
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
      }

      const isSuccess = response?.status >= 200 && response?.status < 300;

      if (!isSuccess) {
        showError(
          response?.data?.message ||
            (editNilaiKhususId
              ? "Gagal mengubah nilai khusus"
              : "Gagal membuat nilai khusus")
        );
        return;
      }

      const targetKelasId = kelasIds.includes(String(selectedKelasId))
        ? selectedKelasId
        : kelasIds[0];

      showSuccess(
        response?.data?.message ||
          (editNilaiKhususId
            ? "Nilai khusus berhasil diubah"
            : "Nilai khusus berhasil dibuat")
      );

      setShowModal(false);
      resetForm();

      if (targetKelasId) {
        setSelectedKelasId(targetKelasId);
        await getNilaiKhususData(targetKelasId);
      }
    } catch (error) {
      console.log(
        editNilaiKhususId
          ? "Gagal mengubah nilai khusus:"
          : "Gagal membuat nilai khusus:",
        error
      );

      const validationMessage = error?.response?.data?.errors
        ? Object.values(error.response.data.errors).flat().join("\n")
        : "";

      showError(
        validationMessage ||
          error?.response?.data?.message ||
          error?.message ||
          (editNilaiKhususId
            ? "Gagal mengubah nilai khusus"
            : "Gagal membuat nilai khusus")
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (item) => {
    if (!item?.id) {
      showError("ID nilai khusus tidak ditemukan");
      return;
    }

    const result = await Swal.fire({
      title: "Apakah Kamu Yakin?",
      text: `Nilai khusus "${item?.title || "-"}" akan dihapus`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
    });

    if (!result.isConfirmed) return;

    setDeletingId(item.id);

    try {
      const response = await APISD.delete(`/api/exam-kokurikuler/${item.id}`, {
        headers: {
          Authorization: resolveToken(),
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      const isSuccess = response?.status >= 200 && response?.status < 300;

      if (!isSuccess) {
        showError(response?.data?.message || "Gagal menghapus nilai khusus");
        return;
      }

      showSuccess(
        response?.data?.message || "Nilai khusus berhasil dihapus"
      );

      await getNilaiKhususData(selectedKelasId);
    } catch (error) {
      console.log("Gagal menghapus nilai khusus:", error);
      showError(error?.response?.data?.message || "Gagal menghapus nilai khusus");
    } finally {
      setDeletingId(null);
    }
  };

  const handleShow = (item) => {
    if (!item?.id) {
      showError("ID nilai khusus tidak ditemukan");
      return;
    }

    if (typeof setSelectedNilaiKhusus === "function") {
      setSelectedNilaiKhusus(item);
      return;
    }

    showError("Halaman detail nilai khusus belum terhubung");
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        aria-labelledby="modal-nilai-khusus"
        centered
        backdrop="static"
        keyboard={false}
        className="nk-form-modal"
      >
        <div className="d-flex header-modal nk-modal-header mb-4">
          <h5>{editNilaiKhususId ? "Update Nilai Khusus" : "Buat Nilai Khusus"}</h5>

          <div className="ml-auto x-close nk-modal-close">
            <FontAwesomeIcon
              icon={faTimes}
              onClick={handleCloseModal}
              aria-label="Tutup modal"
            />
          </div>
        </div>

        <hr className="nk-modal-divider" />

        <Modal.Body className="modal-body nk-modal-body mt-2">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-12">
                <div className="mt-3 label-group-form">
                  <label className="label-name-form">Judul</label>
                  <input
                    className="label-input-form"
                    autoFocus
                    type="text"
                    name="title"
                    placeholder="Masukkan judul nilai khusus"
                    value={formData.title}
                    onChange={handleChangeForm}
                    disabled={isSubmitting}
                    maxLength={255}
                  />
                </div>
              </div>

              <div className="col-md-12">
                <div className="mt-4 label-group-form">
                  <label className="label-name-form">Kegiatan</label>
                  <select
                    className="label-input-form"
                    name="ysb_type_activities_id"
                    value={formData.ysb_type_activities_id}
                    onChange={handleChangeForm}
                    disabled={
                      isSubmitting || isFetchingType || !activityReferenceKelasId
                    }
                  >
                    <option value="">
                      {isFetchingType ? "Memuat kegiatan..." : "Pilih kegiatan"}
                    </option>

                    {typeActivityData.map((item) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.name_activities || "-"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-md-12">
                <div className="mt-4">
                  <label className="nk-section-label">Aspek Kegiatan</label>

                  <div className="nk-option-box">
                    {isFetchingSubActivity ? (
                      <div className="nk-empty-option">Memuat aspek kegiatan...</div>
                    ) : !formData.ysb_type_activities_id ? (
                      <div className="nk-empty-option">
                        Aspek belum tersedia. Pilih kegiatan terlebih dahulu.
                      </div>
                    ) : subActivityData.length > 0 ? (
                      <div className="nk-aspect-grid">
                        {subActivityData.map((subActivity) => {
                          const subActivityId = safeString(subActivity?.id);
                          const isChecked = selectedSubActivityIds.includes(
                            subActivityId
                          );

                          return (
                            <label
                              key={subActivityId}
                              className={`nk-aspect-item ${
                                isChecked ? "is-selected" : ""
                              }`}
                            >
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() =>
                                  handleChangeSubActivity(subActivityId)
                                }
                                disabled={isSubmitting}
                              />

                              <span>
                                {subActivity?.name_sub_activities || "-"}
                              </span>
                            </label>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="nk-empty-option">
                        Aspek untuk kegiatan ini belum tersedia.
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="mt-4">
                  <div className="nk-section-heading">
                    <div>
                      <label className="nk-section-label mb-0">
                        Kelas dan Tanggal Penilaian
                      </label>
                      <small className="nk-section-helper">
                        Centang kelas, lalu tentukan tanggal penilaian pada setiap
                        kelas yang dipilih.
                      </small>
                    </div>

                    {kelasList.length > 0 && (
                      <button
                        type="button"
                        className="nk-select-all-btn"
                        onClick={handleSelectAllKelas}
                        disabled={isSubmitting}
                      >
                        {isAllKelasSelected
                          ? "Batal Pilih Semua"
                          : "Pilih Semua"}
                      </button>
                    )}
                  </div>

                  <div className="">
                    {kelasList.length > 0 ? (
                      <div className="nk-class-list">
                        {kelasList.map((kelas, index) => {
                          const kelasId = safeString(kelas?.ysb_kelas_id);
                          const isChecked = selectedKelasIds.includes(kelasId);
                          const jadwal = getJadwalKelas(kelasId);

                          return (
                            <div
                              key={kelasId || index}
                              className={`nk-class-card ${
                                isChecked ? "is-selected" : ""
                              }`}
                            >
                              <label className="nk-class-check">
                                <input
                                  type="checkbox"
                                  checked={isChecked}
                                  onChange={() => handleChangeKelas(kelasId)}
                                  disabled={isSubmitting || !kelasId}
                                />

                                <span>
                                  {kelas?.nama_kelas ||
                                    kelas?.name_kelas ||
                                    kelas?.kelas_name ||
                                    "-"}
                                </span>
                              </label>

                              {isChecked && (
                                <div className="nk-date-panel">
                                  <div className="nk-date-icon">
                                    <FontAwesomeIcon icon={faCalendarDays} />
                                  </div>

                                  <div className="nk-date-content">
                                    <label htmlFor={`nk-date-${kelasId}`}>
                                      Tanggal Penilaian
                                    </label>

                                    <input
                                      id={`nk-date-${kelasId}`}
                                      className="nk-date-input"
                                      type="date"
                                      value={jadwal?.date_exam || ""}
                                      onChange={(event) =>
                                        handleChangeTanggalKelas(
                                          kelasId,
                                          event.target.value
                                        )
                                      }
                                      onClick={(event) => {
                                        if (
                                          typeof event.currentTarget.showPicker ===
                                          "function"
                                        ) {
                                          event.currentTarget.showPicker();
                                        }
                                      }}
                                      disabled={isSubmitting}
                                    />

                                    <small>
                                      Klik kolom tanggal untuk membuka kalender.
                                    </small>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="nk-empty-option">Kelas belum tersedia</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="mt-4 label-group-form">
                  <label className="label-name-form">Keterangan</label>
                  <input
                    className="label-input-form"
                    type="text"
                    name="description"
                    placeholder="Masukkan keterangan"
                    value={formData.description}
                    onChange={handleChangeForm}
                    disabled={isSubmitting}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex mt-4 nk-modal-actions">
              <Button
                type="button"
                className="btn btn-light"
                onClick={handleCloseModal}
                disabled={isSubmitting}
                style={{
                  borderRadius: 10,
                  fontWeight: 600,
                  padding: "8px 14px",
                }}
              >
                Batal
              </Button>

              <Button
                className="btn-modal-create"
                type="submit"
                disabled={isSubmitting}
                style={{
                  borderRadius: 12,
                  padding: "8px 14px",
                  boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                  fontWeight: 600,
                }}
              >
                {isSubmitting ? (
                  <>
                    <i className="fa fa-spinner fa-spin mr-2" />
                    Menyimpan...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon
                      icon={editNilaiKhususId ? faSave : faPlus}
                    />{" "}
                    {editNilaiKhususId ? "Perbarui" : "Tambahkan"}
                  </>
                )}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <div
        className="d-flex mt-4 mb-4"
        style={{
          gap: 12,
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div className="at-search">
          <input
            className="at-input"
            placeholder="Cari nilai khusus"
            value={searchKeyword}
            onChange={(event) => setSearchKeyword(event.target.value)}
          />
        </div>

        <div className="ml-auto">
          <button
            type="button"
            onClick={handleOpenAdd}
            className="btn btn-create nilai-khusus-create-btn"
            disabled={kelasList.length === 0}
          >
            <FontAwesomeIcon icon={faPlus} /> Buat Nilai Khusus
          </button>
        </div>
      </div>

      <Col
        xl="12"
        sm="12"
        style={{
          paddingLeft: 0,
          paddingRight: 0,
          minWidth: 0,
        }}
      >
        <div className="mt-3 body-table nilai-khusus-table-wrapper">
          <table
            className="table table-hover custom-hover-table table-border-style nilai-khusus-table"
            id="basic-datatable"
          >
            <thead>
              <tr>
                <th className="nk-col-date">Tanggal Dibuat</th>
                <th className="nk-col-creator">Dibuat Oleh</th>
                <th className="nk-col-title">Judul</th>
                <th className="nk-col-type">Kegiatan</th>
                <th className="nk-col-assessed">Sudah Dinilai</th>
                <th className="nk-col-action">Aksi</th>
              </tr>
            </thead>

            <tbody>
              {isFetching ? (
                <tr>
                  <td colSpan="6" className="text-center" style={{ padding: 20 }}>
                    Mengambil data nilai khusus...
                  </td>
                </tr>
              ) : !selectedKelasId ? (
                <tr>
                  <td colSpan="6" className="text-center" style={{ padding: 20 }}>
                    Kelas belum tersedia
                  </td>
                </tr>
              ) : filteredData.length > 0 ? (
                filteredData.map((row, index) => (
                  <tr key={row?.id || index}>
                    <td className="nk-cell-date" data-label="Tanggal Dibuat">
                      {formatDate(row?.created_at)}
                    </td>

                    <td className="nk-cell-creator" data-label="Dibuat Oleh">
                      <div
                        className="nk-ellipsis"
                        title={row?.creator_name || "-"}
                      >
                        {row?.creator_name || "-"}
                      </div>
                    </td>

                    <td className="nk-cell-title" data-label="Judul">
                      <div className="nk-main-text">{row?.title || "-"}</div>

                      {/* {row?.kelas_name ? (
                        <div className="nk-secondary-text">{row.kelas_name}</div>
                      ) : null} */}
                    </td>

                    <td className="nk-cell-type" data-label="Kegiatan">
                      <div className="nk-main-text">
                        {row?.type_activity_name || "-"}
                      </div>

                      {/* {row?.sub_activity_name ? (
                        <div className="nk-secondary-text">
                          Aspek: {row.sub_activity_name}
                        </div>
                      ) : null} */}
                    </td>

                    <td className="nk-cell-assessed" data-label="Sudah Dinilai">
                      <span className="nk-assessed-badge">
                        {getAssessedText(row)}
                      </span>
                    </td>

                    <td className="nk-cell-action" data-label="Aksi">
                      <div className="nk-action-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-primary nk-action-btn"
                          onClick={() => handleShow(row)}
                          title="Lihat detail"
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </button>

                        <button
                          type="button"
                          className="btn btn-sm btn-warning nk-action-btn"
                          onClick={() => handleOpenEdit(row)}
                          title="Edit"
                        >
                          <FontAwesomeIcon icon={faPenToSquare} />
                        </button>

                        <button
                          type="button"
                          className="btn btn-sm btn-danger nk-action-btn"
                          onClick={() => handleDelete(row)}
                          disabled={deletingId === row?.id}
                          title="Hapus"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center" style={{ padding: 20 }}>
                    Data nilai khusus 
                    belum tersedia
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Col>

      <style>
        {`
          .nk-form-modal .modal-content {
            border: 0;
            border-radius: 14px;
            overflow: hidden;
          }

          .nk-modal-header {
            align-items: center;
            padding: 20px 22px 14px;
          }

          .nk-modal-header h5 {
            margin: 0;
            color: #111827;
            font-size: 18px;
            font-weight: 700;
          }

          .nk-modal-close {
            color: #111827;
            cursor: pointer;
            font-size: 17px;
            line-height: 1;
          }

          .nk-modal-close svg {
            pointer-events: ${isSubmitting ? "none" : "auto"};
            opacity: ${isSubmitting ? "0.45" : "1"};
          }

          .nk-modal-divider {
            margin: 0;
            border-color: #e5e7eb;
          }

          .nk-modal-body {
            padding: 8px 22px 22px;
            max-height: calc(100vh - 150px);
            overflow-y: auto;
          }

          .nk-section-label {
            display: block;
            margin-bottom: 10px;
            color: #374151;
            font-size: 14px;
            font-weight: 700;
          }

          .nk-section-heading {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 14px;
            margin-bottom: 10px;
          }

          .nk-section-helper {
            display: block;
            margin-top: 4px;
            color: #6b7280;
            font-size: 12px;
            font-weight: 500;
            line-height: 1.5;
          }

          .nk-select-all-btn {
            flex-shrink: 0;
            border: 0;
            background: transparent;
            color: #3f5bea;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
          }

          .nk-select-all-btn:disabled {
            cursor: not-allowed;
            opacity: 0.55;
          }

          .nk-option-box {
            min-height: 54px;
            padding: 13px 14px;
            border: 1px solid #9bb5ff;
            border-radius: 12px;
            background: #ffffff;
          }

          .nk-empty-option {
            color: #6b7280;
            font-size: 13px;
            font-weight: 600;
          }

          .nk-aspect-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
            gap: 10px;
          }

          .nk-aspect-item {
            display: flex;
            align-items: flex-start;
            gap: 9px;
            min-height: 42px;
            margin: 0;
            padding: 9px 10px;
            border: 1px solid #e5e7eb;
            border-radius: 10px;
            color: #374151;
            background: #ffffff;
            font-size: 13px;
            font-weight: 600;
            line-height: 1.4;
            cursor: pointer;
            transition: 0.2s ease;
          }

          .nk-aspect-item:hover {
            border-color: #9bb5ff;
            background: #f8fbff;
          }

          .nk-aspect-item.is-selected {
            border-color: #9bb5ff;
            color: #3f5bea;
            background: #f4f7ff;
          }

          .nk-aspect-item input,
          .nk-class-check input {
            flex: 0 0 auto;
            margin-top: 2px;
            accent-color: #3f5bea;
          }

          .nk-class-container {
            padding: 12px 14px;
          }

          .nk-class-list {
            display: grid;
            gap: 12px;
          }

          .nk-class-card {
            padding: 12px;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            background: #ffffff;
            transition: 0.2s ease;
          }

          .nk-class-card.is-selected {
            border-color: #9bb5ff;
            background: #f8fbff;
          }

          .nk-class-check {
            display: flex;
            align-items: center;
            gap: 9px;
            margin: 0;
            color: #374151;
            font-size: 14px;
            font-weight: 700;
            cursor: pointer;
          }

          .nk-class-card.is-selected .nk-class-check {
            color: #3f5bea;
          }

          .nk-date-panel {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            margin-top: 12px;
            padding: 12px;
            border: 1px solid #dbe5ff;
            border-radius: 11px;
            background: #ffffff;
          }

          .nk-date-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 38px;
            height: 38px;
            flex: 0 0 38px;
            border-radius: 10px;
            background: #eef3ff;
            color: #3f5bea;
          }

          .nk-date-content {
            flex: 1;
            min-width: 0;
          }

          .nk-date-content label {
            display: block;
            margin-bottom: 6px;
            color: #374151;
            font-size: 12px;
            font-weight: 700;
          }

          .nk-date-input {
            width: 100%;
            height: 42px;
            padding: 8px 12px;
            border: 1px solid #9bb5ff;
            border-radius: 10px;
            outline: none;
            background: #ffffff;
            color: #111827;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
          }

          .nk-date-input:focus {
            border-color: #3f5bea;
            box-shadow: 0 0 0 3px rgba(67, 104, 197, 0.12);
          }

          .nk-date-content small {
            display: block;
            margin-top: 5px;
            color: #6b7280;
            font-size: 11px;
            font-weight: 500;
          }

          .nk-modal-actions {
            justify-content: flex-end;
            gap: 10px;
            flex-wrap: wrap;
          }

          .nilai-khusus-create-btn {
            flex-shrink: 0;
            border-radius: 12px;
            padding: 8px 14px;
            box-shadow: 0 10px 24px rgba(108, 99, 255, 0.18);
            font-weight: 600;
            white-space: nowrap;
          }

          .nilai-khusus-table-wrapper {
            width: 100%;
            max-width: 100%;
            overflow: hidden;
          }

          .nilai-khusus-table {
            width: 100% !important;
            max-width: 100%;
            table-layout: fixed;
            margin-bottom: 0;
          }

          .nilai-khusus-table th,
          .nilai-khusus-table td {
            padding: 11px 8px;
            vertical-align: middle;
            font-size: 13px;
            line-height: 1.4;
          }

          .nilai-khusus-table th {
            white-space: normal;
            overflow-wrap: break-word;
            text-align: center;
          }

          .nk-col-date {
            width: 16%;
          }

          .nk-col-creator {
            width: 22%;
          }

          .nk-col-title {
            width: 13%;
          }

          .nk-col-type {
            width: 17%;
          }

          .nk-col-assessed {
            width: 13%;
          }

          .nk-col-action {
            width: 19%;
          }

          .nk-cell-date {
            white-space: normal;
          }

          .nk-ellipsis {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .nk-main-text {
            color: #111827;
            font-weight: 700;
            overflow-wrap: anywhere;
          }

          .nk-secondary-text {
            margin-top: 3px;
            color: #6b7280;
            font-size: 11px;
            overflow-wrap: anywhere;
          }

          .nk-cell-assessed,
          .nk-cell-action {
            text-align: center;
          }

          .nk-assessed-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 32px;
            padding: 5px 9px;
            border-radius: 999px;
            background: #dcfce7;
            color: #15803d;
            font-size: 12px;
            font-weight: 700;
          }

          .nk-action-group {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
            flex-wrap: nowrap;
          }

          .nk-action-btn {
            width: 31px;
            height: 31px;
            padding: 0;
            border-radius: 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 31px;
            font-size: 12px;
          }

          .nk-action-group .btn-warning {
            color: #ffffff;
          }

          @media (max-width: 1200px) {
            .nilai-khusus-table th,
            .nilai-khusus-table td {
              padding: 9px 6px;
              font-size: 12px;
            }

            .nk-col-date {
              width: 16%;
            }

            .nk-col-creator {
              width: 20%;
            }

            .nk-col-title {
              width: 13%;
            }

            .nk-col-type {
              width: 17%;
            }

            .nk-col-assessed {
              width: 14%;
            }

            .nk-col-action {
              width: 20%;
            }

            .nk-action-btn {
              width: 28px;
              height: 28px;
              flex-basis: 28px;
              font-size: 11px;
            }
          }

          @media (max-width: 991px) {
            .nk-col-creator,
            .nk-cell-creator {
              display: none;
            }

            .nk-col-date {
              width: 19%;
            }

            .nk-col-title {
              width: 16%;
            }

            .nk-col-type {
              width: 23%;
            }

            .nk-col-assessed {
              width: 17%;
            }

            .nk-col-action {
              width: 25%;
            }
          }

          @media (max-width: 767px) {
            .nk-modal-body {
              padding-left: 16px;
              padding-right: 16px;
            }

            .nk-section-heading {
              flex-direction: column;
              align-items: stretch;
            }

            .nk-select-all-btn {
              align-self: flex-end;
            }

            .nk-aspect-grid {
              grid-template-columns: 1fr;
            }

            .nk-date-panel {
              flex-direction: column;
            }

            .nilai-khusus-create-btn {
              width: 100%;
            }

            .nilai-khusus-table-wrapper {
              overflow: visible;
              background: transparent;
            }

            .nilai-khusus-table,
            .nilai-khusus-table tbody,
            .nilai-khusus-table tr,
            .nilai-khusus-table td {
              display: block;
              width: 100%;
            }

            .nilai-khusus-table thead {
              display: none;
            }

            .nilai-khusus-table tbody {
              display: grid;
              gap: 12px;
            }

            .nilai-khusus-table tbody tr {
              overflow: hidden;
              border: 1px solid #e5e7eb;
              border-radius: 14px;
              background: #ffffff;
              box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
            }

            .nilai-khusus-table tbody td {
              display: flex;
              align-items: flex-start;
              justify-content: space-between;
              gap: 12px;
              min-height: 42px;
              padding: 10px 13px;
              border-bottom: 1px solid #f1f5f9;
              text-align: right;
            }

            .nilai-khusus-table tbody td:last-child {
              border-bottom: 0;
            }

            .nilai-khusus-table tbody td::before {
              content: attr(data-label);
              flex: 0 0 40%;
              color: #64748b;
              font-size: 11px;
              font-weight: 800;
              text-align: left;
              text-transform: uppercase;
            }

            .nk-cell-creator {
              display: flex;
            }

            .nk-ellipsis {
              width: 60%;
              white-space: normal;
              overflow-wrap: anywhere;
              text-align: right;
            }

            .nk-cell-title,
            .nk-cell-type {
              text-align: right;
            }

            .nk-cell-assessed,
            .nk-cell-action {
              align-items: center !important;
            }

            .nk-action-group {
              flex: 1;
              justify-content: flex-end;
            }
          }
        `}
      </style>
    </>
  );
}
